import React from 'react';

export default (props) => {
    return (
        <div className="contact">
          <ContactInfo
            name="Alec Resende"
            title="Creator"
            email="universalsequences@gmail.com"
          />
          <ContactInfo
            name="Thomas Sottile"
            title="Legal/Designated DMCA Agent"
            email="tjsottile@gmail.com"
            addressLines={["20 Broad St, Apt. 2309", "New York, NY 10005"]}
            description="Send all DMCA takedown requests to this email or address:"
          />
        </div>
    );
};

const ContactInfo = ({name, title, email, addressLines, description}) => {
    return (
        <div className="contact-info">
          <div className="name">
            {name}
          </div>
          <div className="job-title">
            {title}
          </div>
          <div className="description">
            {description}
          </div>
          <div className="email">
            Email: {email}
          </div>
        {addressLines ? 
          <div className="address">
            {addressLines.map(
                line =>
                    <div className="address-line">
                      {line}
                    </div>
                             )}
          </div>
         :
         ''}
        </div>
    );
};
